import { Badge } from 'evergreen-ui';

export const PaymentStatusBadge = ({ bookingOrOrder = {} }) => {
    if (!bookingOrOrder?._id || !bookingOrOrder?.payment_status) return null;
    if (!bookingOrOrder.total_cost) return null;
    const { payment_status } = bookingOrOrder;

    switch (payment_status) {
        case 'paid':
            return (
                <Badge color="green" data-cy="payment_status_badge">
                    Paid
                </Badge>
            );
        case 'awaiting_payment':
            return (
                <Badge color="yellow" data-cy="payment_status_badge">
                    To Be Paid
                </Badge>
            );
        case 'overdue':
            return (
                <Badge color="orange" data-cy="payment_status_badge">
                    Overdue
                </Badge>
            );
        case 'cancelled':
            return (
                <Badge color="red" data-cy="payment_status_badge">
                    Cancelled
                </Badge>
            );
        default:
            return null;
    }
};
